import { Peer } from './Peer';
import WebSocketTransport from './transports/WebSocketTransport';
import WebTransportTransport from './transports/WebTransportTransport';

/**
 * Expose Peer class.
 *
 * @type {Class}
 */
export default { Peer, WebSocketTransport, WebTransportTransport };
